import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { editMultipleField } from 'api/field'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

import type { FieldModel } from 'store/state/field'

export type ReactivateFieldsProps = {
  fields: FieldModel[]
  callback: () => void
}

export default function ReactivateFields(props: ReactivateFieldsProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { fields, callback } = props

  const closePopup = () => dispatch(closeModal())

  const onSubmit = useCallback(() => {
    const data: { id: number; retiredAt: null }[] = []
    for (let i = 0; i < fields.length; i++) {
      data.push({ id: fields[i].id, retiredAt: null })
    }
    //@ts-expect-error
    dispatch(editMultipleField(data, callback))
    dispatch(closeModal())
  }, [fields, callback, dispatch])

  return (
    <ModalContainer>
      <div>
        {t('reactivate_items', {
          count: fields.length,
          item: fields.length > 1 ? t('fields') : t('field'),
        })}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          {t('reactivate')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
